import React from 'react';
import './index.scss';
import App from './app/App';
import {AppBridgeEvent} from './model/appBridge';
import {appBridgeCheckContext, createBridgedPage, getPageHash, isSameMount, unmountBridgedPage} from './services/appBridge';
import {initStaticCodebooks} from './store/codebooks';
import configureAppStore, {rootReducer} from './store/configureStore';

// Global redux store persisted between page renders
export const store = configureAppStore();

// Redux types
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

// Init bridge
(window as any).kwsAppBridgeCallback = (e: AppBridgeEvent) => {
    // console.log('[appBridge] callback', e.type, e);
    renderBridgedPage(e);
};

// Init global components
store.dispatch(initStaticCodebooks());

// tokens of mounts still waiting for their root element; a destroy (or a newer
// mount of the same page) invalidates the token so the pending retry gives up
const pendingMounts: { [hash: string]: { mountId?: number } } = {};

function renderBridgedPage(event: AppBridgeEvent, attempt?: number, token?: { mountId?: number }) {
    appBridgeCheckContext(event, store.dispatch);

    if (event.type === 'page') {
        const hash = getPageHash(event);
        if (!token) {
            token = {mountId: event.mountId};
            pendingMounts[hash] = token;
        } else if (pendingMounts[hash] !== token) {
            // page was destroyed while waiting for its root element
            return;
        }

        const rootElm = document.getElementById(event.rootId) as HTMLElement;
        attempt = (attempt || 0) + 1;
        if (!rootElm && attempt < 5) {
            setTimeout(() => {
                console.log("Retrying " + event.rootId + " at " + attempt);
                // give ng time to render template (temporary solution)
                renderBridgedPage(event, attempt, token);
            }, Math.pow(2, attempt) * 100);
            return;
        }
        delete pendingMounts[hash];

        if (!rootElm) {
            console.warn('[appBridge] root element #' + event.rootId + ' not found, page ' + event.page + ' not mounted');
        } else {
            createBridgedPage(event, rootElm).render(<App appEvent={event}/>);
        }
    } else if (event.type === 'page-destroy') {
        const hash = getPageHash(event);
        if (pendingMounts[hash] && isSameMount(event, pendingMounts[hash].mountId)) {
            delete pendingMounts[hash];
        }
        unmountBridgedPage(event);
    }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
